import React from 'react';
import  { useFetchJobPost } from '../../hooks/useFetchData';
import Detail from '../../components/shared/Detail';
import Header from '../../components/shared/Header';
import Breadcrumb from '../../components/shared/Breadcrumbs';


const JobDetailPage = () => {
  const { data: job_post, loading, error } = useFetchJobPost(); 
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "求人情報投稿一覧", path: "/job" },
    { label: `${job_post.title}`, path: "/job/:postId" },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;
  const table_list = {
    カテゴリー: job_post.job_cat_name,
    必要英語スキル: job_post.english_name,
    時給: job_post.wages ? `$ ${job_post.wages} / houer`: "ー",
    週末時給 : job_post.wages2 ? `$ ${job_post.wages2} / hour`: "ー",
  }

  return (
      <div>
        <Header />
        <Breadcrumb items={breadcrumbs} />
        <Detail
          item={job_post}
          table_list={table_list} 
          type="job"
        />
      </div>
  );
};

export default JobDetailPage;
